<template>
  <div class="appointment-list-component">
    <div v-if="selectedAppointments && selectedAppointments.length > 0" class="event-details">
      <div v-for="selectedAppointment in selectedAppointments" :key="selectedAppointment.id" class="event">
        <div class="d-flex">
          <i class="far fa-calendar-alt me-3"></i>
          <div class="content">
            <p>
              <strong>{{ selectedAppointment.starts_at | moment("L - LT") }}</strong><br>
              {{ selectedAppointment.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="showEmpty && selectedAppointments !== null" class="event-details">
      <div class="event">
        <div class="d-flex">
          <i class="far fa-calendar-alt me-3"></i>
          <div class="content">
            <p>
              <strong>No appointments</strong><br>
              There are no appointments for this day.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedAppointments: null,
    };
  },
  props: {
    showEmpty: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$root.$on('updateAppointments', this.updateAppointments);
  },
  created() {
    this.updateAppointments();
  },

  methods: {
    updateAppointments(data = null) {
      this.selectedAppointments = data;
    },
  },
};
</script>
